export type BlueprintIcons_16Id =
  | "add-clip"
  | "add-column-left"
  | "add-column-right"
  | "add-location"
  | "add-row-bottom"
  | "add-row-top"
  | "add-to-artifact"
  | "add-to-folder"
  | "add"
  | "aimpoints-target"
  | "airplane"
  | "align-center"
  | "align-justify"
  | "align-left"
  | "align-right"
  | "alignment-bottom"
  | "alignment-horizontal-center"
  | "alignment-left"
  | "alignment-right"
  | "alignment-top"
  | "alignment-vertical-center"
  | "ammunition"
  | "anchor"
  | "annotation"
  | "antenna"
  | "app-header"
  | "application"
  | "applications"
  | "archive"
  | "area-of-interest"
  | "array-boolean"
  | "array-date"
  | "array-floating-point"
  | "array-numeric"
  | "array-string"
  | "array-timestamp"
  | "array"
  | "arrow-bottom-left"
  | "arrow-bottom-right"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-top-left"
  | "arrow-top-right"
  | "arrow-up"
  | "arrows-horizontal"
  | "arrows-vertical"
  | "asterisk"
  | "at"
  | "automatic-updates"
  | "axle"
  | "backlink"
  | "badge"
  | "ban-circle"
  | "bank-account"
  | "barcode"
  | "blank"
  | "blocked-person"
  | "bold"
  | "book"
  | "bookmark"
  | "box"
  | "briefcase"
  | "bring-data"
  | "bug"
  | "buggy"
  | "build"
  | "calculator"
  | "calendar"
  | "camera"
  | "caret-down"
  | "caret-left"
  | "caret-right"
  | "caret-up"
  | "cargo-ship"
  | "cell-tower"
  | "changes"
  | "chart"
  | "chat"
  | "chevron-backward"
  | "chevron-down"
  | "chevron-forward"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "circle-arrow-down"
  | "circle-arrow-left"
  | "circle-arrow-right"
  | "circle-arrow-up"
  | "circle"
  | "citation"
  | "clean"
  | "clip"
  | "clipboard"
  | "cloud-download"
  | "cloud-upload"
  | "cloud"
  | "code-block"
  | "code"
  | "cog"
  | "collapse-all"
  | "color-fill"
  | "column-layout"
  | "comment"
  | "comparison"
  | "compass"
  | "compressed"
  | "confirm"
  | "console"
  | "contrast"
  | "control"
  | "credit-card"
  | "cross-circle"
  | "cross"
  | "crown"
  | "cube-add"
  | "cube-remove"
  | "cube"
  | "curved-range-chart"
  | "cut"
  | "cycle"
  | "dashboard"
  | "data-connection"
  | "data-lineage"
  | "database"
  | "delete"
  | "delta"
  | "derive-column"
  | "desktop"
  | "detection"
  | "diagnosis"
  | "diagram-tree"
  | "direction-left"
  | "direction-right"
  | "disable"
  | "divide"
  | "document-open"
  | "document-share"
  | "document"
  | "dollar"
  | "dot"
  | "double-caret-horizontal"
  | "double-caret-vertical"
  | "double-chevron-down"
  | "double-chevron-left"
  | "double-chevron-right"
  | "double-chevron-up"
  | "doughnut-chart"
  | "download"
  | "drag-handle-horizontal"
  | "drag-handle-vertical"
  | "draw"
  | "drawer-left-filled"
  | "drawer-left"
  | "drawer-right-filled"
  | "drawer-right"
  | "drive-time"
  | "duplicate"
  | "edit"
  | "eject"
  | "emoji"
  | "endorsed"
  | "envelope"
  | "equals"
  | "eraser"
  | "error"
  | "euro"
  | "exchange"
  | "exclude-row"
  | "expand-all"
  | "export"
  | "eye-off"
  | "eye-on"
  | "eye-open"
  | "fast-backward"
  | "fast-forward"
  | "feed-subscribed"
  | "feed"
  | "film"
  | "filter-keep"
  | "filter-list"
  | "filter-open"
  | "filter-remove"
  | "filter"
  | "flag"
  | "flame"
  | "flash"
  | "floating-point"
  | "floppy-disk"
  | "flow-branch"
  | "flow-end"
  | "flow-linear"
  | "flow-review-branch"
  | "flow-review"
  | "flows"
  | "folder-close"
  | "folder-new"
  | "folder-open"
  | "folder-shared-open"
  | "folder-shared"
  | "follower"
  | "following"
  | "font"
  | "fork"
  | "form"
  | "fuel"
  | "full-circle"
  | "full-stacked-chart"
  | "fullscreen"
  | "function"
  | "gantt-chart"
  | "geofence"
  | "geolocation"
  | "geosearch"
  | "geotime"
  | "git-branch"
  | "git-commit"
  | "git-merge"
  | "git-new-branch"
  | "git-pull"
  | "git-push"
  | "git-repo"
  | "glass"
  | "globe-network"
  | "globe"
  | "graph-remove"
  | "graph"
  | "greater-than-or-equal-to"
  | "greater-than"
  | "grid-view"
  | "grid"
  | "group-objects"
  | "grouped-bar-chart"
  | "hand-down"
  | "hand-left"
  | "hand-right"
  | "hand-up"
  | "hand"
  | "hat"
  | "header-one"
  | "header-three"
  | "header-two"
  | "header"
  | "headset"
  | "heart-broken"
  | "heart"
  | "heat-grid"
  | "heatmap"
  | "helicopter"
  | "help"
  | "helper-management"
  | "high-priority"
  | "high-voltage-pole"
  | "highlight"
  | "history"
  | "home"
  | "horizontal-bar-chart-asc"
  | "horizontal-bar-chart-desc"
  | "horizontal-bar-chart"
  | "horizontal-distribution"
  | "horizontal-inbetween"
  | "hurricane"
  | "id-number"
  | "image-rotate-left"
  | "image-rotate-right"
  | "import"
  | "inbox-filtered"
  | "inbox-geo"
  | "inbox-search"
  | "inbox-update"
  | "inbox"
  | "info-sign"
  | "inheritance"
  | "inherited-group"
  | "inner-join"
  | "insert"
  | "intelligence"
  | "intersection"
  | "ip-address"
  | "issue-closed"
  | "issue-new"
  | "issue"
  | "italic"
  | "join-table"
  | "key-backspace"
  | "key-command"
  | "key-control"
  | "key-delete"
  | "key-enter"
  | "key-escape"
  | "key-option"
  | "key-shift"
  | "key-tab"
  | "key"
  | "known-vehicle"
  | "lab-test"
  | "label"
  | "layer-outline"
  | "layer"
  | "layers"
  | "layout-auto"
  | "layout-balloon"
  | "layout-circle"
  | "layout-grid"
  | "layout-group-by"
  | "layout-hierarchy"
  | "layout-linear"
  | "layout-skew-grid"
  | "layout-sorted-clusters"
  | "layout"
  | "learning"
  | "left-join"
  | "lengthen-text"
  | "less-than-or-equal-to"
  | "less-than"
  | "lifesaver"
  | "lightbulb"
  | "lightning"
  | "link"
  | "list-columns"
  | "list-detail-view"
  | "list"
  | "locate"
  | "lock"
  | "locomotive"
  | "log-in"
  | "log-out"
  | "low-voltage-pole"
  | "manual"
  | "manually-entered-data"
  | "many-to-many"
  | "many-to-one"
  | "map-create"
  | "map-marker"
  | "map"
  | "maximize"
  | "media"
  | "menu-closed"
  | "menu-open"
  | "menu"
  | "merge-columns"
  | "merge-links"
  | "microphone"
  | "minimize"
  | "minus"
  | "mobile-phone"
  | "mobile-video"
  | "modal-filled"
  | "modal"
  | "model"
  | "moon"
  | "more"
  | "mountain"
  | "move"
  | "mugshot"
  | "multi-select"
  | "music"
  | "nest"
  | "new-drawing"
  | "new-grid-item"
  | "new-layer"
  | "new-layers"
  | "new-link"
  | "new-object"
  | "new-person"
  | "new-prescription"
  | "new-shield"
  | "new-text-box"
  | "ninja"
  | "not-equal-to"
  | "notifications-snooze"
  | "notifications-updated"
  | "notifications"
  | "numbered-list"
  | "numerical"
  | "office"
  | "offline"
  | "oil-field"
  | "one-column"
  | "one-to-many"
  | "one-to-one"
  | "open-application"
  | "outdated"
  | "page-layout"
  | "panel-stats"
  | "panel-table"
  | "paperclip"
  | "paragraph"
  | "paste-variable"
  | "path-search"
  | "path"
  | "pause"
  | "people"
  | "percentage"
  | "person"
  | "phone-call"
  | "phone-forward"
  | "phone"
  | "pie-chart"
  | "pin"
  | "pivot-table"
  | "pivot"
  | "play"
  | "playbook"
  | "plus"
  | "polygon-filter"
  | "power"
  | "predictive-analysis"
  | "prescription"
  | "presentation"
  | "print"
  | "projects"
  | "properties"
  | "property"
  | "publish-function"
  | "pulse"
  | "rain"
  | "random"
  | "record"
  | "rect-height"
  | "rect-width"
  | "rectangle"
  | "redo"
  | "refresh"
  | "regex"
  | "regression-chart"
  | "remove-column-left"
  | "remove-column-right"
  | "remove-column"
  | "remove-row-bottom"
  | "remove-row-top"
  | "remove"
  | "repeat"
  | "reset"
  | "resolve"
  | "rig"
  | "right-join"
  | "ring"
  | "rocket-slant"
  | "rocket"
  | "rotate-document"
  | "rotate-page"
  | "route"
  | "satellite"
  | "saved"
  | "scatter-plot"
  | "search-around"
  | "search-template"
  | "search-text"
  | "search"
  | "segmented-control"
  | "select"
  | "selection"
  | "send-message"
  | "send-to-graph"
  | "send-to-map"
  | "send-to"
  | "sensor"
  | "series-add"
  | "series-configuration"
  | "series-derived"
  | "series-filtered"
  | "series-search"
  | "settings"
  | "shapes"
  | "share"
  | "shared-filter"
  | "shield"
  | "ship"
  | "shop"
  | "shopping-cart"
  | "shorten-text"
  | "signal-search"
  | "sim-card"
  | "slash"
  | "small-cross"
  | "small-info-sign"
  | "small-minus"
  | "small-plus"
  | "small-square"
  | "small-tick"
  | "snowflake"
  | "social-media"
  | "sort-alphabetical-desc"
  | "sort-alphabetical"
  | "sort-asc"
  | "sort-desc"
  | "sort-numerical-desc"
  | "sort-numerical"
  | "sort"
  | "spell-check"
  | "split-columns"
  | "square"
  | "stacked-chart"
  | "stadium-geometry"
  | "star-empty"
  | "star"
  | "step-backward"
  | "step-chart"
  | "step-forward"
  | "stop"
  | "stopwatch"
  | "strikethrough"
  | "style"
  | "subscript"
  | "superscript"
  | "swap-horizontal"
  | "swap-vertical"
  | "switch"
  | "symbol-circle"
  | "symbol-cross"
  | "symbol-diamond"
  | "symbol-rectangle"
  | "symbol-square"
  | "symbol-triangle-down"
  | "symbol-triangle-up"
  | "syringe"
  | "tag"
  | "take-action"
  | "tank"
  | "target"
  | "taxi"
  | "temperature"
  | "text-highlight"
  | "th-derived"
  | "th-disconnect"
  | "th-filtered"
  | "th-list"
  | "th"
  | "third-party"
  | "thumbs-down"
  | "thumbs-up"
  | "tick-circle"
  | "tick"
  | "time"
  | "timeline-area-chart"
  | "timeline-bar-chart"
  | "timeline-events"
  | "timeline-line-chart"
  | "tint"
  | "torch"
  | "tractor"
  | "train"
  | "translate"
  | "trash"
  | "tree"
  | "trending-down"
  | "trending-up"
  | "truck"
  | "two-columns"
  | "unarchive"
  | "underline"
  | "undo"
  | "ungroup-objects"
  | "unknown-vehicle"
  | "unlink"
  | "unlock"
  | "unpin"
  | "unresolve"
  | "updated"
  | "upload"
  | "user"
  | "variable"
  | "vertical-bar-chart-asc"
  | "vertical-bar-chart-desc"
  | "vertical-distribution"
  | "vertical-inbetween"
  | "video"
  | "virus"
  | "volume-down"
  | "volume-off"
  | "volume-up"
  | "walk"
  | "warning-sign"
  | "waterfall-chart"
  | "waves"
  | "widget-button"
  | "widget-footer"
  | "widget-header"
  | "widget"
  | "wind"
  | "wrench"
  | "zoom-in"
  | "zoom-out"
  | "zoom-to-fit";

export type BlueprintIcons_16Key =
  | "AddClip"
  | "AddColumnLeft"
  | "AddColumnRight"
  | "AddLocation"
  | "AddRowBottom"
  | "AddRowTop"
  | "AddToArtifact"
  | "AddToFolder"
  | "Add"
  | "AimpointsTarget"
  | "Airplane"
  | "AlignCenter"
  | "AlignJustify"
  | "AlignLeft"
  | "AlignRight"
  | "AlignmentBottom"
  | "AlignmentHorizontalCenter"
  | "AlignmentLeft"
  | "AlignmentRight"
  | "AlignmentTop"
  | "AlignmentVerticalCenter"
  | "Ammunition"
  | "Anchor"
  | "Annotation"
  | "Antenna"
  | "AppHeader"
  | "Application"
  | "Applications"
  | "Archive"
  | "AreaOfInterest"
  | "ArrayBoolean"
  | "ArrayDate"
  | "ArrayFloatingPoint"
  | "ArrayNumeric"
  | "ArrayString"
  | "ArrayTimestamp"
  | "Array"
  | "ArrowBottomLeft"
  | "ArrowBottomRight"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowTopLeft"
  | "ArrowTopRight"
  | "ArrowUp"
  | "ArrowsHorizontal"
  | "ArrowsVertical"
  | "Asterisk"
  | "At"
  | "AutomaticUpdates"
  | "Axle"
  | "Backlink"
  | "Badge"
  | "BanCircle"
  | "BankAccount"
  | "Barcode"
  | "Blank"
  | "BlockedPerson"
  | "Bold"
  | "Book"
  | "Bookmark"
  | "Box"
  | "Briefcase"
  | "BringData"
  | "Bug"
  | "Buggy"
  | "Build"
  | "Calculator"
  | "Calendar"
  | "Camera"
  | "CaretDown"
  | "CaretLeft"
  | "CaretRight"
  | "CaretUp"
  | "CargoShip"
  | "CellTower"
  | "Changes"
  | "Chart"
  | "Chat"
  | "ChevronBackward"
  | "ChevronDown"
  | "ChevronForward"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "CircleArrowDown"
  | "CircleArrowLeft"
  | "CircleArrowRight"
  | "CircleArrowUp"
  | "Circle"
  | "Citation"
  | "Clean"
  | "Clip"
  | "Clipboard"
  | "CloudDownload"
  | "CloudUpload"
  | "Cloud"
  | "CodeBlock"
  | "Code"
  | "Cog"
  | "CollapseAll"
  | "ColorFill"
  | "ColumnLayout"
  | "Comment"
  | "Comparison"
  | "Compass"
  | "Compressed"
  | "Confirm"
  | "Console"
  | "Contrast"
  | "Control"
  | "CreditCard"
  | "CrossCircle"
  | "Cross"
  | "Crown"
  | "CubeAdd"
  | "CubeRemove"
  | "Cube"
  | "CurvedRangeChart"
  | "Cut"
  | "Cycle"
  | "Dashboard"
  | "DataConnection"
  | "DataLineage"
  | "Database"
  | "Delete"
  | "Delta"
  | "DeriveColumn"
  | "Desktop"
  | "Detection"
  | "Diagnosis"
  | "DiagramTree"
  | "DirectionLeft"
  | "DirectionRight"
  | "Disable"
  | "Divide"
  | "DocumentOpen"
  | "DocumentShare"
  | "Document"
  | "Dollar"
  | "Dot"
  | "DoubleCaretHorizontal"
  | "DoubleCaretVertical"
  | "DoubleChevronDown"
  | "DoubleChevronLeft"
  | "DoubleChevronRight"
  | "DoubleChevronUp"
  | "DoughnutChart"
  | "Download"
  | "DragHandleHorizontal"
  | "DragHandleVertical"
  | "Draw"
  | "DrawerLeftFilled"
  | "DrawerLeft"
  | "DrawerRightFilled"
  | "DrawerRight"
  | "DriveTime"
  | "Duplicate"
  | "Edit"
  | "Eject"
  | "Emoji"
  | "Endorsed"
  | "Envelope"
  | "Equals"
  | "Eraser"
  | "Error"
  | "Euro"
  | "Exchange"
  | "ExcludeRow"
  | "ExpandAll"
  | "Export"
  | "EyeOff"
  | "EyeOn"
  | "EyeOpen"
  | "FastBackward"
  | "FastForward"
  | "FeedSubscribed"
  | "Feed"
  | "Film"
  | "FilterKeep"
  | "FilterList"
  | "FilterOpen"
  | "FilterRemove"
  | "Filter"
  | "Flag"
  | "Flame"
  | "Flash"
  | "FloatingPoint"
  | "FloppyDisk"
  | "FlowBranch"
  | "FlowEnd"
  | "FlowLinear"
  | "FlowReviewBranch"
  | "FlowReview"
  | "Flows"
  | "FolderClose"
  | "FolderNew"
  | "FolderOpen"
  | "FolderSharedOpen"
  | "FolderShared"
  | "Follower"
  | "Following"
  | "Font"
  | "Fork"
  | "Form"
  | "Fuel"
  | "FullCircle"
  | "FullStackedChart"
  | "Fullscreen"
  | "Function"
  | "GanttChart"
  | "Geofence"
  | "Geolocation"
  | "Geosearch"
  | "Geotime"
  | "GitBranch"
  | "GitCommit"
  | "GitMerge"
  | "GitNewBranch"
  | "GitPull"
  | "GitPush"
  | "GitRepo"
  | "Glass"
  | "GlobeNetwork"
  | "Globe"
  | "GraphRemove"
  | "Graph"
  | "GreaterThanOrEqualTo"
  | "GreaterThan"
  | "GridView"
  | "Grid"
  | "GroupObjects"
  | "GroupedBarChart"
  | "HandDown"
  | "HandLeft"
  | "HandRight"
  | "HandUp"
  | "Hand"
  | "Hat"
  | "HeaderOne"
  | "HeaderThree"
  | "HeaderTwo"
  | "Header"
  | "Headset"
  | "HeartBroken"
  | "Heart"
  | "HeatGrid"
  | "Heatmap"
  | "Helicopter"
  | "Help"
  | "HelperManagement"
  | "HighPriority"
  | "HighVoltagePole"
  | "Highlight"
  | "History"
  | "Home"
  | "HorizontalBarChartAsc"
  | "HorizontalBarChartDesc"
  | "HorizontalBarChart"
  | "HorizontalDistribution"
  | "HorizontalInbetween"
  | "Hurricane"
  | "IdNumber"
  | "ImageRotateLeft"
  | "ImageRotateRight"
  | "Import"
  | "InboxFiltered"
  | "InboxGeo"
  | "InboxSearch"
  | "InboxUpdate"
  | "Inbox"
  | "InfoSign"
  | "Inheritance"
  | "InheritedGroup"
  | "InnerJoin"
  | "Insert"
  | "Intelligence"
  | "Intersection"
  | "IpAddress"
  | "IssueClosed"
  | "IssueNew"
  | "Issue"
  | "Italic"
  | "JoinTable"
  | "KeyBackspace"
  | "KeyCommand"
  | "KeyControl"
  | "KeyDelete"
  | "KeyEnter"
  | "KeyEscape"
  | "KeyOption"
  | "KeyShift"
  | "KeyTab"
  | "Key"
  | "KnownVehicle"
  | "LabTest"
  | "Label"
  | "LayerOutline"
  | "Layer"
  | "Layers"
  | "LayoutAuto"
  | "LayoutBalloon"
  | "LayoutCircle"
  | "LayoutGrid"
  | "LayoutGroupBy"
  | "LayoutHierarchy"
  | "LayoutLinear"
  | "LayoutSkewGrid"
  | "LayoutSortedClusters"
  | "Layout"
  | "Learning"
  | "LeftJoin"
  | "LengthenText"
  | "LessThanOrEqualTo"
  | "LessThan"
  | "Lifesaver"
  | "Lightbulb"
  | "Lightning"
  | "Link"
  | "ListColumns"
  | "ListDetailView"
  | "List"
  | "Locate"
  | "Lock"
  | "Locomotive"
  | "LogIn"
  | "LogOut"
  | "LowVoltagePole"
  | "Manual"
  | "ManuallyEnteredData"
  | "ManyToMany"
  | "ManyToOne"
  | "MapCreate"
  | "MapMarker"
  | "Map"
  | "Maximize"
  | "Media"
  | "MenuClosed"
  | "MenuOpen"
  | "Menu"
  | "MergeColumns"
  | "MergeLinks"
  | "Microphone"
  | "Minimize"
  | "Minus"
  | "MobilePhone"
  | "MobileVideo"
  | "ModalFilled"
  | "Modal"
  | "Model"
  | "Moon"
  | "More"
  | "Mountain"
  | "Move"
  | "Mugshot"
  | "MultiSelect"
  | "Music"
  | "Nest"
  | "NewDrawing"
  | "NewGridItem"
  | "NewLayer"
  | "NewLayers"
  | "NewLink"
  | "NewObject"
  | "NewPerson"
  | "NewPrescription"
  | "NewShield"
  | "NewTextBox"
  | "Ninja"
  | "NotEqualTo"
  | "NotificationsSnooze"
  | "NotificationsUpdated"
  | "Notifications"
  | "NumberedList"
  | "Numerical"
  | "Office"
  | "Offline"
  | "OilField"
  | "OneColumn"
  | "OneToMany"
  | "OneToOne"
  | "OpenApplication"
  | "Outdated"
  | "PageLayout"
  | "PanelStats"
  | "PanelTable"
  | "Paperclip"
  | "Paragraph"
  | "PasteVariable"
  | "PathSearch"
  | "Path"
  | "Pause"
  | "People"
  | "Percentage"
  | "Person"
  | "PhoneCall"
  | "PhoneForward"
  | "Phone"
  | "PieChart"
  | "Pin"
  | "PivotTable"
  | "Pivot"
  | "Play"
  | "Playbook"
  | "Plus"
  | "PolygonFilter"
  | "Power"
  | "PredictiveAnalysis"
  | "Prescription"
  | "Presentation"
  | "Print"
  | "Projects"
  | "Properties"
  | "Property"
  | "PublishFunction"
  | "Pulse"
  | "Rain"
  | "Random"
  | "Record"
  | "RectHeight"
  | "RectWidth"
  | "Rectangle"
  | "Redo"
  | "Refresh"
  | "Regex"
  | "RegressionChart"
  | "RemoveColumnLeft"
  | "RemoveColumnRight"
  | "RemoveColumn"
  | "RemoveRowBottom"
  | "RemoveRowTop"
  | "Remove"
  | "Repeat"
  | "Reset"
  | "Resolve"
  | "Rig"
  | "RightJoin"
  | "Ring"
  | "RocketSlant"
  | "Rocket"
  | "RotateDocument"
  | "RotatePage"
  | "Route"
  | "Satellite"
  | "Saved"
  | "ScatterPlot"
  | "SearchAround"
  | "SearchTemplate"
  | "SearchText"
  | "Search"
  | "SegmentedControl"
  | "Select"
  | "Selection"
  | "SendMessage"
  | "SendToGraph"
  | "SendToMap"
  | "SendTo"
  | "Sensor"
  | "SeriesAdd"
  | "SeriesConfiguration"
  | "SeriesDerived"
  | "SeriesFiltered"
  | "SeriesSearch"
  | "Settings"
  | "Shapes"
  | "Share"
  | "SharedFilter"
  | "Shield"
  | "Ship"
  | "Shop"
  | "ShoppingCart"
  | "ShortenText"
  | "SignalSearch"
  | "SimCard"
  | "Slash"
  | "SmallCross"
  | "SmallInfoSign"
  | "SmallMinus"
  | "SmallPlus"
  | "SmallSquare"
  | "SmallTick"
  | "Snowflake"
  | "SocialMedia"
  | "SortAlphabeticalDesc"
  | "SortAlphabetical"
  | "SortAsc"
  | "SortDesc"
  | "SortNumericalDesc"
  | "SortNumerical"
  | "Sort"
  | "SpellCheck"
  | "SplitColumns"
  | "Square"
  | "StackedChart"
  | "StadiumGeometry"
  | "StarEmpty"
  | "Star"
  | "StepBackward"
  | "StepChart"
  | "StepForward"
  | "Stop"
  | "Stopwatch"
  | "Strikethrough"
  | "Style"
  | "Subscript"
  | "Superscript"
  | "SwapHorizontal"
  | "SwapVertical"
  | "Switch"
  | "SymbolCircle"
  | "SymbolCross"
  | "SymbolDiamond"
  | "SymbolRectangle"
  | "SymbolSquare"
  | "SymbolTriangleDown"
  | "SymbolTriangleUp"
  | "Syringe"
  | "Tag"
  | "TakeAction"
  | "Tank"
  | "Target"
  | "Taxi"
  | "Temperature"
  | "TextHighlight"
  | "ThDerived"
  | "ThDisconnect"
  | "ThFiltered"
  | "ThList"
  | "Th"
  | "ThirdParty"
  | "ThumbsDown"
  | "ThumbsUp"
  | "TickCircle"
  | "Tick"
  | "Time"
  | "TimelineAreaChart"
  | "TimelineBarChart"
  | "TimelineEvents"
  | "TimelineLineChart"
  | "Tint"
  | "Torch"
  | "Tractor"
  | "Train"
  | "Translate"
  | "Trash"
  | "Tree"
  | "TrendingDown"
  | "TrendingUp"
  | "Truck"
  | "TwoColumns"
  | "Unarchive"
  | "Underline"
  | "Undo"
  | "UngroupObjects"
  | "UnknownVehicle"
  | "Unlink"
  | "Unlock"
  | "Unpin"
  | "Unresolve"
  | "Updated"
  | "Upload"
  | "User"
  | "Variable"
  | "VerticalBarChartAsc"
  | "VerticalBarChartDesc"
  | "VerticalDistribution"
  | "VerticalInbetween"
  | "Video"
  | "Virus"
  | "VolumeDown"
  | "VolumeOff"
  | "VolumeUp"
  | "Walk"
  | "WarningSign"
  | "WaterfallChart"
  | "Waves"
  | "WidgetButton"
  | "WidgetFooter"
  | "WidgetHeader"
  | "Widget"
  | "Wind"
  | "Wrench"
  | "ZoomIn"
  | "ZoomOut"
  | "ZoomToFit";

export enum BlueprintIcons_16 {
  AddClip = "add-clip",
  AddColumnLeft = "add-column-left",
  AddColumnRight = "add-column-right",
  AddLocation = "add-location",
  AddRowBottom = "add-row-bottom",
  AddRowTop = "add-row-top",
  AddToArtifact = "add-to-artifact",
  AddToFolder = "add-to-folder",
  Add = "add",
  AimpointsTarget = "aimpoints-target",
  Airplane = "airplane",
  AlignCenter = "align-center",
  AlignJustify = "align-justify",
  AlignLeft = "align-left",
  AlignRight = "align-right",
  AlignmentBottom = "alignment-bottom",
  AlignmentHorizontalCenter = "alignment-horizontal-center",
  AlignmentLeft = "alignment-left",
  AlignmentRight = "alignment-right",
  AlignmentTop = "alignment-top",
  AlignmentVerticalCenter = "alignment-vertical-center",
  Ammunition = "ammunition",
  Anchor = "anchor",
  Annotation = "annotation",
  Antenna = "antenna",
  AppHeader = "app-header",
  Application = "application",
  Applications = "applications",
  Archive = "archive",
  AreaOfInterest = "area-of-interest",
  ArrayBoolean = "array-boolean",
  ArrayDate = "array-date",
  ArrayFloatingPoint = "array-floating-point",
  ArrayNumeric = "array-numeric",
  ArrayString = "array-string",
  ArrayTimestamp = "array-timestamp",
  Array = "array",
  ArrowBottomLeft = "arrow-bottom-left",
  ArrowBottomRight = "arrow-bottom-right",
  ArrowDown = "arrow-down",
  ArrowLeft = "arrow-left",
  ArrowRight = "arrow-right",
  ArrowTopLeft = "arrow-top-left",
  ArrowTopRight = "arrow-top-right",
  ArrowUp = "arrow-up",
  ArrowsHorizontal = "arrows-horizontal",
  ArrowsVertical = "arrows-vertical",
  Asterisk = "asterisk",
  At = "at",
  AutomaticUpdates = "automatic-updates",
  Axle = "axle",
  Backlink = "backlink",
  Badge = "badge",
  BanCircle = "ban-circle",
  BankAccount = "bank-account",
  Barcode = "barcode",
  Blank = "blank",
  BlockedPerson = "blocked-person",
  Bold = "bold",
  Book = "book",
  Bookmark = "bookmark",
  Box = "box",
  Briefcase = "briefcase",
  BringData = "bring-data",
  Bug = "bug",
  Buggy = "buggy",
  Build = "build",
  Calculator = "calculator",
  Calendar = "calendar",
  Camera = "camera",
  CaretDown = "caret-down",
  CaretLeft = "caret-left",
  CaretRight = "caret-right",
  CaretUp = "caret-up",
  CargoShip = "cargo-ship",
  CellTower = "cell-tower",
  Changes = "changes",
  Chart = "chart",
  Chat = "chat",
  ChevronBackward = "chevron-backward",
  ChevronDown = "chevron-down",
  ChevronForward = "chevron-forward",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  CircleArrowDown = "circle-arrow-down",
  CircleArrowLeft = "circle-arrow-left",
  CircleArrowRight = "circle-arrow-right",
  CircleArrowUp = "circle-arrow-up",
  Circle = "circle",
  Citation = "citation",
  Clean = "clean",
  Clip = "clip",
  Clipboard = "clipboard",
  CloudDownload = "cloud-download",
  CloudUpload = "cloud-upload",
  Cloud = "cloud",
  CodeBlock = "code-block",
  Code = "code",
  Cog = "cog",
  CollapseAll = "collapse-all",
  ColorFill = "color-fill",
  ColumnLayout = "column-layout",
  Comment = "comment",
  Comparison = "comparison",
  Compass = "compass",
  Compressed = "compressed",
  Confirm = "confirm",
  Console = "console",
  Contrast = "contrast",
  Control = "control",
  CreditCard = "credit-card",
  CrossCircle = "cross-circle",
  Cross = "cross",
  Crown = "crown",
  CubeAdd = "cube-add",
  CubeRemove = "cube-remove",
  Cube = "cube",
  CurvedRangeChart = "curved-range-chart",
  Cut = "cut",
  Cycle = "cycle",
  Dashboard = "dashboard",
  DataConnection = "data-connection",
  DataLineage = "data-lineage",
  Database = "database",
  Delete = "delete",
  Delta = "delta",
  DeriveColumn = "derive-column",
  Desktop = "desktop",
  Detection = "detection",
  Diagnosis = "diagnosis",
  DiagramTree = "diagram-tree",
  DirectionLeft = "direction-left",
  DirectionRight = "direction-right",
  Disable = "disable",
  Divide = "divide",
  DocumentOpen = "document-open",
  DocumentShare = "document-share",
  Document = "document",
  Dollar = "dollar",
  Dot = "dot",
  DoubleCaretHorizontal = "double-caret-horizontal",
  DoubleCaretVertical = "double-caret-vertical",
  DoubleChevronDown = "double-chevron-down",
  DoubleChevronLeft = "double-chevron-left",
  DoubleChevronRight = "double-chevron-right",
  DoubleChevronUp = "double-chevron-up",
  DoughnutChart = "doughnut-chart",
  Download = "download",
  DragHandleHorizontal = "drag-handle-horizontal",
  DragHandleVertical = "drag-handle-vertical",
  Draw = "draw",
  DrawerLeftFilled = "drawer-left-filled",
  DrawerLeft = "drawer-left",
  DrawerRightFilled = "drawer-right-filled",
  DrawerRight = "drawer-right",
  DriveTime = "drive-time",
  Duplicate = "duplicate",
  Edit = "edit",
  Eject = "eject",
  Emoji = "emoji",
  Endorsed = "endorsed",
  Envelope = "envelope",
  Equals = "equals",
  Eraser = "eraser",
  Error = "error",
  Euro = "euro",
  Exchange = "exchange",
  ExcludeRow = "exclude-row",
  ExpandAll = "expand-all",
  Export = "export",
  EyeOff = "eye-off",
  EyeOn = "eye-on",
  EyeOpen = "eye-open",
  FastBackward = "fast-backward",
  FastForward = "fast-forward",
  FeedSubscribed = "feed-subscribed",
  Feed = "feed",
  Film = "film",
  FilterKeep = "filter-keep",
  FilterList = "filter-list",
  FilterOpen = "filter-open",
  FilterRemove = "filter-remove",
  Filter = "filter",
  Flag = "flag",
  Flame = "flame",
  Flash = "flash",
  FloatingPoint = "floating-point",
  FloppyDisk = "floppy-disk",
  FlowBranch = "flow-branch",
  FlowEnd = "flow-end",
  FlowLinear = "flow-linear",
  FlowReviewBranch = "flow-review-branch",
  FlowReview = "flow-review",
  Flows = "flows",
  FolderClose = "folder-close",
  FolderNew = "folder-new",
  FolderOpen = "folder-open",
  FolderSharedOpen = "folder-shared-open",
  FolderShared = "folder-shared",
  Follower = "follower",
  Following = "following",
  Font = "font",
  Fork = "fork",
  Form = "form",
  Fuel = "fuel",
  FullCircle = "full-circle",
  FullStackedChart = "full-stacked-chart",
  Fullscreen = "fullscreen",
  Function = "function",
  GanttChart = "gantt-chart",
  Geofence = "geofence",
  Geolocation = "geolocation",
  Geosearch = "geosearch",
  Geotime = "geotime",
  GitBranch = "git-branch",
  GitCommit = "git-commit",
  GitMerge = "git-merge",
  GitNewBranch = "git-new-branch",
  GitPull = "git-pull",
  GitPush = "git-push",
  GitRepo = "git-repo",
  Glass = "glass",
  GlobeNetwork = "globe-network",
  Globe = "globe",
  GraphRemove = "graph-remove",
  Graph = "graph",
  GreaterThanOrEqualTo = "greater-than-or-equal-to",
  GreaterThan = "greater-than",
  GridView = "grid-view",
  Grid = "grid",
  GroupObjects = "group-objects",
  GroupedBarChart = "grouped-bar-chart",
  HandDown = "hand-down",
  HandLeft = "hand-left",
  HandRight = "hand-right",
  HandUp = "hand-up",
  Hand = "hand",
  Hat = "hat",
  HeaderOne = "header-one",
  HeaderThree = "header-three",
  HeaderTwo = "header-two",
  Header = "header",
  Headset = "headset",
  HeartBroken = "heart-broken",
  Heart = "heart",
  HeatGrid = "heat-grid",
  Heatmap = "heatmap",
  Helicopter = "helicopter",
  Help = "help",
  HelperManagement = "helper-management",
  HighPriority = "high-priority",
  HighVoltagePole = "high-voltage-pole",
  Highlight = "highlight",
  History = "history",
  Home = "home",
  HorizontalBarChartAsc = "horizontal-bar-chart-asc",
  HorizontalBarChartDesc = "horizontal-bar-chart-desc",
  HorizontalBarChart = "horizontal-bar-chart",
  HorizontalDistribution = "horizontal-distribution",
  HorizontalInbetween = "horizontal-inbetween",
  Hurricane = "hurricane",
  IdNumber = "id-number",
  ImageRotateLeft = "image-rotate-left",
  ImageRotateRight = "image-rotate-right",
  Import = "import",
  InboxFiltered = "inbox-filtered",
  InboxGeo = "inbox-geo",
  InboxSearch = "inbox-search",
  InboxUpdate = "inbox-update",
  Inbox = "inbox",
  InfoSign = "info-sign",
  Inheritance = "inheritance",
  InheritedGroup = "inherited-group",
  InnerJoin = "inner-join",
  Insert = "insert",
  Intelligence = "intelligence",
  Intersection = "intersection",
  IpAddress = "ip-address",
  IssueClosed = "issue-closed",
  IssueNew = "issue-new",
  Issue = "issue",
  Italic = "italic",
  JoinTable = "join-table",
  KeyBackspace = "key-backspace",
  KeyCommand = "key-command",
  KeyControl = "key-control",
  KeyDelete = "key-delete",
  KeyEnter = "key-enter",
  KeyEscape = "key-escape",
  KeyOption = "key-option",
  KeyShift = "key-shift",
  KeyTab = "key-tab",
  Key = "key",
  KnownVehicle = "known-vehicle",
  LabTest = "lab-test",
  Label = "label",
  LayerOutline = "layer-outline",
  Layer = "layer",
  Layers = "layers",
  LayoutAuto = "layout-auto",
  LayoutBalloon = "layout-balloon",
  LayoutCircle = "layout-circle",
  LayoutGrid = "layout-grid",
  LayoutGroupBy = "layout-group-by",
  LayoutHierarchy = "layout-hierarchy",
  LayoutLinear = "layout-linear",
  LayoutSkewGrid = "layout-skew-grid",
  LayoutSortedClusters = "layout-sorted-clusters",
  Layout = "layout",
  Learning = "learning",
  LeftJoin = "left-join",
  LengthenText = "lengthen-text",
  LessThanOrEqualTo = "less-than-or-equal-to",
  LessThan = "less-than",
  Lifesaver = "lifesaver",
  Lightbulb = "lightbulb",
  Lightning = "lightning",
  Link = "link",
  ListColumns = "list-columns",
  ListDetailView = "list-detail-view",
  List = "list",
  Locate = "locate",
  Lock = "lock",
  Locomotive = "locomotive",
  LogIn = "log-in",
  LogOut = "log-out",
  LowVoltagePole = "low-voltage-pole",
  Manual = "manual",
  ManuallyEnteredData = "manually-entered-data",
  ManyToMany = "many-to-many",
  ManyToOne = "many-to-one",
  MapCreate = "map-create",
  MapMarker = "map-marker",
  Map = "map",
  Maximize = "maximize",
  Media = "media",
  MenuClosed = "menu-closed",
  MenuOpen = "menu-open",
  Menu = "menu",
  MergeColumns = "merge-columns",
  MergeLinks = "merge-links",
  Microphone = "microphone",
  Minimize = "minimize",
  Minus = "minus",
  MobilePhone = "mobile-phone",
  MobileVideo = "mobile-video",
  ModalFilled = "modal-filled",
  Modal = "modal",
  Model = "model",
  Moon = "moon",
  More = "more",
  Mountain = "mountain",
  Move = "move",
  Mugshot = "mugshot",
  MultiSelect = "multi-select",
  Music = "music",
  Nest = "nest",
  NewDrawing = "new-drawing",
  NewGridItem = "new-grid-item",
  NewLayer = "new-layer",
  NewLayers = "new-layers",
  NewLink = "new-link",
  NewObject = "new-object",
  NewPerson = "new-person",
  NewPrescription = "new-prescription",
  NewShield = "new-shield",
  NewTextBox = "new-text-box",
  Ninja = "ninja",
  NotEqualTo = "not-equal-to",
  NotificationsSnooze = "notifications-snooze",
  NotificationsUpdated = "notifications-updated",
  Notifications = "notifications",
  NumberedList = "numbered-list",
  Numerical = "numerical",
  Office = "office",
  Offline = "offline",
  OilField = "oil-field",
  OneColumn = "one-column",
  OneToMany = "one-to-many",
  OneToOne = "one-to-one",
  OpenApplication = "open-application",
  Outdated = "outdated",
  PageLayout = "page-layout",
  PanelStats = "panel-stats",
  PanelTable = "panel-table",
  Paperclip = "paperclip",
  Paragraph = "paragraph",
  PasteVariable = "paste-variable",
  PathSearch = "path-search",
  Path = "path",
  Pause = "pause",
  People = "people",
  Percentage = "percentage",
  Person = "person",
  PhoneCall = "phone-call",
  PhoneForward = "phone-forward",
  Phone = "phone",
  PieChart = "pie-chart",
  Pin = "pin",
  PivotTable = "pivot-table",
  Pivot = "pivot",
  Play = "play",
  Playbook = "playbook",
  Plus = "plus",
  PolygonFilter = "polygon-filter",
  Power = "power",
  PredictiveAnalysis = "predictive-analysis",
  Prescription = "prescription",
  Presentation = "presentation",
  Print = "print",
  Projects = "projects",
  Properties = "properties",
  Property = "property",
  PublishFunction = "publish-function",
  Pulse = "pulse",
  Rain = "rain",
  Random = "random",
  Record = "record",
  RectHeight = "rect-height",
  RectWidth = "rect-width",
  Rectangle = "rectangle",
  Redo = "redo",
  Refresh = "refresh",
  Regex = "regex",
  RegressionChart = "regression-chart",
  RemoveColumnLeft = "remove-column-left",
  RemoveColumnRight = "remove-column-right",
  RemoveColumn = "remove-column",
  RemoveRowBottom = "remove-row-bottom",
  RemoveRowTop = "remove-row-top",
  Remove = "remove",
  Repeat = "repeat",
  Reset = "reset",
  Resolve = "resolve",
  Rig = "rig",
  RightJoin = "right-join",
  Ring = "ring",
  RocketSlant = "rocket-slant",
  Rocket = "rocket",
  RotateDocument = "rotate-document",
  RotatePage = "rotate-page",
  Route = "route",
  Satellite = "satellite",
  Saved = "saved",
  ScatterPlot = "scatter-plot",
  SearchAround = "search-around",
  SearchTemplate = "search-template",
  SearchText = "search-text",
  Search = "search",
  SegmentedControl = "segmented-control",
  Select = "select",
  Selection = "selection",
  SendMessage = "send-message",
  SendToGraph = "send-to-graph",
  SendToMap = "send-to-map",
  SendTo = "send-to",
  Sensor = "sensor",
  SeriesAdd = "series-add",
  SeriesConfiguration = "series-configuration",
  SeriesDerived = "series-derived",
  SeriesFiltered = "series-filtered",
  SeriesSearch = "series-search",
  Settings = "settings",
  Shapes = "shapes",
  Share = "share",
  SharedFilter = "shared-filter",
  Shield = "shield",
  Ship = "ship",
  Shop = "shop",
  ShoppingCart = "shopping-cart",
  ShortenText = "shorten-text",
  SignalSearch = "signal-search",
  SimCard = "sim-card",
  Slash = "slash",
  SmallCross = "small-cross",
  SmallInfoSign = "small-info-sign",
  SmallMinus = "small-minus",
  SmallPlus = "small-plus",
  SmallSquare = "small-square",
  SmallTick = "small-tick",
  Snowflake = "snowflake",
  SocialMedia = "social-media",
  SortAlphabeticalDesc = "sort-alphabetical-desc",
  SortAlphabetical = "sort-alphabetical",
  SortAsc = "sort-asc",
  SortDesc = "sort-desc",
  SortNumericalDesc = "sort-numerical-desc",
  SortNumerical = "sort-numerical",
  Sort = "sort",
  SpellCheck = "spell-check",
  SplitColumns = "split-columns",
  Square = "square",
  StackedChart = "stacked-chart",
  StadiumGeometry = "stadium-geometry",
  StarEmpty = "star-empty",
  Star = "star",
  StepBackward = "step-backward",
  StepChart = "step-chart",
  StepForward = "step-forward",
  Stop = "stop",
  Stopwatch = "stopwatch",
  Strikethrough = "strikethrough",
  Style = "style",
  Subscript = "subscript",
  Superscript = "superscript",
  SwapHorizontal = "swap-horizontal",
  SwapVertical = "swap-vertical",
  Switch = "switch",
  SymbolCircle = "symbol-circle",
  SymbolCross = "symbol-cross",
  SymbolDiamond = "symbol-diamond",
  SymbolRectangle = "symbol-rectangle",
  SymbolSquare = "symbol-square",
  SymbolTriangleDown = "symbol-triangle-down",
  SymbolTriangleUp = "symbol-triangle-up",
  Syringe = "syringe",
  Tag = "tag",
  TakeAction = "take-action",
  Tank = "tank",
  Target = "target",
  Taxi = "taxi",
  Temperature = "temperature",
  TextHighlight = "text-highlight",
  ThDerived = "th-derived",
  ThDisconnect = "th-disconnect",
  ThFiltered = "th-filtered",
  ThList = "th-list",
  Th = "th",
  ThirdParty = "third-party",
  ThumbsDown = "thumbs-down",
  ThumbsUp = "thumbs-up",
  TickCircle = "tick-circle",
  Tick = "tick",
  Time = "time",
  TimelineAreaChart = "timeline-area-chart",
  TimelineBarChart = "timeline-bar-chart",
  TimelineEvents = "timeline-events",
  TimelineLineChart = "timeline-line-chart",
  Tint = "tint",
  Torch = "torch",
  Tractor = "tractor",
  Train = "train",
  Translate = "translate",
  Trash = "trash",
  Tree = "tree",
  TrendingDown = "trending-down",
  TrendingUp = "trending-up",
  Truck = "truck",
  TwoColumns = "two-columns",
  Unarchive = "unarchive",
  Underline = "underline",
  Undo = "undo",
  UngroupObjects = "ungroup-objects",
  UnknownVehicle = "unknown-vehicle",
  Unlink = "unlink",
  Unlock = "unlock",
  Unpin = "unpin",
  Unresolve = "unresolve",
  Updated = "updated",
  Upload = "upload",
  User = "user",
  Variable = "variable",
  VerticalBarChartAsc = "vertical-bar-chart-asc",
  VerticalBarChartDesc = "vertical-bar-chart-desc",
  VerticalDistribution = "vertical-distribution",
  VerticalInbetween = "vertical-inbetween",
  Video = "video",
  Virus = "virus",
  VolumeDown = "volume-down",
  VolumeOff = "volume-off",
  VolumeUp = "volume-up",
  Walk = "walk",
  WarningSign = "warning-sign",
  WaterfallChart = "waterfall-chart",
  Waves = "waves",
  WidgetButton = "widget-button",
  WidgetFooter = "widget-footer",
  WidgetHeader = "widget-header",
  Widget = "widget",
  Wind = "wind",
  Wrench = "wrench",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
  ZoomToFit = "zoom-to-fit",
}

export const BLUEPRINT_ICONS_16_CODEPOINTS: { [key in BlueprintIcons_16]: string } = {
  [BlueprintIcons_16.AddClip]: "61697",
  [BlueprintIcons_16.AddColumnLeft]: "61698",
  [BlueprintIcons_16.AddColumnRight]: "61699",
  [BlueprintIcons_16.AddLocation]: "61700",
  [BlueprintIcons_16.AddRowBottom]: "61701",
  [BlueprintIcons_16.AddRowTop]: "61702",
  [BlueprintIcons_16.AddToArtifact]: "61703",
  [BlueprintIcons_16.AddToFolder]: "61704",
  [BlueprintIcons_16.Add]: "61705",
  [BlueprintIcons_16.AimpointsTarget]: "62261",
  [BlueprintIcons_16.Airplane]: "61706",
  [BlueprintIcons_16.AlignCenter]: "61707",
  [BlueprintIcons_16.AlignJustify]: "61708",
  [BlueprintIcons_16.AlignLeft]: "61709",
  [BlueprintIcons_16.AlignRight]: "61710",
  [BlueprintIcons_16.AlignmentBottom]: "61711",
  [BlueprintIcons_16.AlignmentHorizontalCenter]: "61712",
  [BlueprintIcons_16.AlignmentLeft]: "61713",
  [BlueprintIcons_16.AlignmentRight]: "61714",
  [BlueprintIcons_16.AlignmentTop]: "61715",
  [BlueprintIcons_16.AlignmentVerticalCenter]: "61716",
  [BlueprintIcons_16.Ammunition]: "62274",
  [BlueprintIcons_16.Anchor]: "62256",
  [BlueprintIcons_16.Annotation]: "61717",
  [BlueprintIcons_16.Antenna]: "61718",
  [BlueprintIcons_16.AppHeader]: "61719",
  [BlueprintIcons_16.Application]: "61720",
  [BlueprintIcons_16.Applications]: "61721",
  [BlueprintIcons_16.Archive]: "61722",
  [BlueprintIcons_16.AreaOfInterest]: "61723",
  [BlueprintIcons_16.ArrayBoolean]: "61724",
  [BlueprintIcons_16.ArrayDate]: "61725",
  [BlueprintIcons_16.ArrayFloatingPoint]: "62253",
  [BlueprintIcons_16.ArrayNumeric]: "61726",
  [BlueprintIcons_16.ArrayString]: "61727",
  [BlueprintIcons_16.ArrayTimestamp]: "61728",
  [BlueprintIcons_16.Array]: "61729",
  [BlueprintIcons_16.ArrowBottomLeft]: "61730",
  [BlueprintIcons_16.ArrowBottomRight]: "61731",
  [BlueprintIcons_16.ArrowDown]: "61732",
  [BlueprintIcons_16.ArrowLeft]: "61733",
  [BlueprintIcons_16.ArrowRight]: "61734",
  [BlueprintIcons_16.ArrowTopLeft]: "61735",
  [BlueprintIcons_16.ArrowTopRight]: "61736",
  [BlueprintIcons_16.ArrowUp]: "61737",
  [BlueprintIcons_16.ArrowsHorizontal]: "61738",
  [BlueprintIcons_16.ArrowsVertical]: "61739",
  [BlueprintIcons_16.Asterisk]: "61740",
  [BlueprintIcons_16.At]: "62257",
  [BlueprintIcons_16.AutomaticUpdates]: "61741",
  [BlueprintIcons_16.Axle]: "62264",
  [BlueprintIcons_16.Backlink]: "61742",
  [BlueprintIcons_16.Badge]: "61743",
  [BlueprintIcons_16.BanCircle]: "61744",
  [BlueprintIcons_16.BankAccount]: "61745",
  [BlueprintIcons_16.Barcode]: "61746",
  [BlueprintIcons_16.Blank]: "61747",
  [BlueprintIcons_16.BlockedPerson]: "61748",
  [BlueprintIcons_16.Bold]: "61749",
  [BlueprintIcons_16.Book]: "61750",
  [BlueprintIcons_16.Bookmark]: "61751",
  [BlueprintIcons_16.Box]: "61752",
  [BlueprintIcons_16.Briefcase]: "61753",
  [BlueprintIcons_16.BringData]: "61754",
  [BlueprintIcons_16.Bug]: "62254",
  [BlueprintIcons_16.Buggy]: "61755",
  [BlueprintIcons_16.Build]: "61756",
  [BlueprintIcons_16.Calculator]: "61757",
  [BlueprintIcons_16.Calendar]: "61758",
  [BlueprintIcons_16.Camera]: "61759",
  [BlueprintIcons_16.CaretDown]: "61760",
  [BlueprintIcons_16.CaretLeft]: "61761",
  [BlueprintIcons_16.CaretRight]: "61762",
  [BlueprintIcons_16.CaretUp]: "61763",
  [BlueprintIcons_16.CargoShip]: "61764",
  [BlueprintIcons_16.CellTower]: "61765",
  [BlueprintIcons_16.Changes]: "61766",
  [BlueprintIcons_16.Chart]: "61767",
  [BlueprintIcons_16.Chat]: "61768",
  [BlueprintIcons_16.ChevronBackward]: "61769",
  [BlueprintIcons_16.ChevronDown]: "61770",
  [BlueprintIcons_16.ChevronForward]: "61771",
  [BlueprintIcons_16.ChevronLeft]: "61772",
  [BlueprintIcons_16.ChevronRight]: "61773",
  [BlueprintIcons_16.ChevronUp]: "61774",
  [BlueprintIcons_16.CircleArrowDown]: "61775",
  [BlueprintIcons_16.CircleArrowLeft]: "61776",
  [BlueprintIcons_16.CircleArrowRight]: "61777",
  [BlueprintIcons_16.CircleArrowUp]: "61778",
  [BlueprintIcons_16.Circle]: "61779",
  [BlueprintIcons_16.Citation]: "61780",
  [BlueprintIcons_16.Clean]: "61781",
  [BlueprintIcons_16.Clip]: "61782",
  [BlueprintIcons_16.Clipboard]: "61783",
  [BlueprintIcons_16.CloudDownload]: "61784",
  [BlueprintIcons_16.CloudUpload]: "61785",
  [BlueprintIcons_16.Cloud]: "61786",
  [BlueprintIcons_16.CodeBlock]: "61787",
  [BlueprintIcons_16.Code]: "61788",
  [BlueprintIcons_16.Cog]: "61789",
  [BlueprintIcons_16.CollapseAll]: "61790",
  [BlueprintIcons_16.ColorFill]: "62248",
  [BlueprintIcons_16.ColumnLayout]: "61791",
  [BlueprintIcons_16.Comment]: "61792",
  [BlueprintIcons_16.Comparison]: "61793",
  [BlueprintIcons_16.Compass]: "61794",
  [BlueprintIcons_16.Compressed]: "61795",
  [BlueprintIcons_16.Confirm]: "61796",
  [BlueprintIcons_16.Console]: "61797",
  [BlueprintIcons_16.Contrast]: "61798",
  [BlueprintIcons_16.Control]: "61799",
  [BlueprintIcons_16.CreditCard]: "61800",
  [BlueprintIcons_16.CrossCircle]: "62262",
  [BlueprintIcons_16.Cross]: "61801",
  [BlueprintIcons_16.Crown]: "61802",
  [BlueprintIcons_16.CubeAdd]: "61803",
  [BlueprintIcons_16.CubeRemove]: "61804",
  [BlueprintIcons_16.Cube]: "61805",
  [BlueprintIcons_16.CurvedRangeChart]: "61806",
  [BlueprintIcons_16.Cut]: "61807",
  [BlueprintIcons_16.Cycle]: "61808",
  [BlueprintIcons_16.Dashboard]: "61809",
  [BlueprintIcons_16.DataConnection]: "61810",
  [BlueprintIcons_16.DataLineage]: "61811",
  [BlueprintIcons_16.Database]: "61812",
  [BlueprintIcons_16.Delete]: "61813",
  [BlueprintIcons_16.Delta]: "61814",
  [BlueprintIcons_16.DeriveColumn]: "61815",
  [BlueprintIcons_16.Desktop]: "61816",
  [BlueprintIcons_16.Detection]: "62273",
  [BlueprintIcons_16.Diagnosis]: "61817",
  [BlueprintIcons_16.DiagramTree]: "61818",
  [BlueprintIcons_16.DirectionLeft]: "61819",
  [BlueprintIcons_16.DirectionRight]: "61820",
  [BlueprintIcons_16.Disable]: "61821",
  [BlueprintIcons_16.Divide]: "62247",
  [BlueprintIcons_16.DocumentOpen]: "61822",
  [BlueprintIcons_16.DocumentShare]: "61823",
  [BlueprintIcons_16.Document]: "61824",
  [BlueprintIcons_16.Dollar]: "61825",
  [BlueprintIcons_16.Dot]: "61826",
  [BlueprintIcons_16.DoubleCaretHorizontal]: "61827",
  [BlueprintIcons_16.DoubleCaretVertical]: "61828",
  [BlueprintIcons_16.DoubleChevronDown]: "61829",
  [BlueprintIcons_16.DoubleChevronLeft]: "61830",
  [BlueprintIcons_16.DoubleChevronRight]: "61831",
  [BlueprintIcons_16.DoubleChevronUp]: "61832",
  [BlueprintIcons_16.DoughnutChart]: "61833",
  [BlueprintIcons_16.Download]: "61834",
  [BlueprintIcons_16.DragHandleHorizontal]: "61835",
  [BlueprintIcons_16.DragHandleVertical]: "61836",
  [BlueprintIcons_16.Draw]: "61837",
  [BlueprintIcons_16.DrawerLeftFilled]: "61838",
  [BlueprintIcons_16.DrawerLeft]: "61839",
  [BlueprintIcons_16.DrawerRightFilled]: "61840",
  [BlueprintIcons_16.DrawerRight]: "61841",
  [BlueprintIcons_16.DriveTime]: "61842",
  [BlueprintIcons_16.Duplicate]: "61843",
  [BlueprintIcons_16.Edit]: "61844",
  [BlueprintIcons_16.Eject]: "61845",
  [BlueprintIcons_16.Emoji]: "61846",
  [BlueprintIcons_16.Endorsed]: "61847",
  [BlueprintIcons_16.Envelope]: "61848",
  [BlueprintIcons_16.Equals]: "61849",
  [BlueprintIcons_16.Eraser]: "61850",
  [BlueprintIcons_16.Error]: "61851",
  [BlueprintIcons_16.Euro]: "61852",
  [BlueprintIcons_16.Exchange]: "61853",
  [BlueprintIcons_16.ExcludeRow]: "61854",
  [BlueprintIcons_16.ExpandAll]: "61855",
  [BlueprintIcons_16.Export]: "61856",
  [BlueprintIcons_16.EyeOff]: "61857",
  [BlueprintIcons_16.EyeOn]: "61858",
  [BlueprintIcons_16.EyeOpen]: "61859",
  [BlueprintIcons_16.FastBackward]: "61860",
  [BlueprintIcons_16.FastForward]: "61861",
  [BlueprintIcons_16.FeedSubscribed]: "61862",
  [BlueprintIcons_16.Feed]: "61863",
  [BlueprintIcons_16.Film]: "61864",
  [BlueprintIcons_16.FilterKeep]: "61865",
  [BlueprintIcons_16.FilterList]: "61866",
  [BlueprintIcons_16.FilterOpen]: "61867",
  [BlueprintIcons_16.FilterRemove]: "61868",
  [BlueprintIcons_16.Filter]: "61869",
  [BlueprintIcons_16.Flag]: "61870",
  [BlueprintIcons_16.Flame]: "61871",
  [BlueprintIcons_16.Flash]: "61872",
  [BlueprintIcons_16.FloatingPoint]: "62252",
  [BlueprintIcons_16.FloppyDisk]: "61873",
  [BlueprintIcons_16.FlowBranch]: "61874",
  [BlueprintIcons_16.FlowEnd]: "61875",
  [BlueprintIcons_16.FlowLinear]: "61876",
  [BlueprintIcons_16.FlowReviewBranch]: "61877",
  [BlueprintIcons_16.FlowReview]: "61878",
  [BlueprintIcons_16.Flows]: "61879",
  [BlueprintIcons_16.FolderClose]: "61880",
  [BlueprintIcons_16.FolderNew]: "61881",
  [BlueprintIcons_16.FolderOpen]: "61882",
  [BlueprintIcons_16.FolderSharedOpen]: "61883",
  [BlueprintIcons_16.FolderShared]: "61884",
  [BlueprintIcons_16.Follower]: "61885",
  [BlueprintIcons_16.Following]: "61886",
  [BlueprintIcons_16.Font]: "61887",
  [BlueprintIcons_16.Fork]: "61888",
  [BlueprintIcons_16.Form]: "61889",
  [BlueprintIcons_16.Fuel]: "62243",
  [BlueprintIcons_16.FullCircle]: "61890",
  [BlueprintIcons_16.FullStackedChart]: "61891",
  [BlueprintIcons_16.Fullscreen]: "61892",
  [BlueprintIcons_16.Function]: "61893",
  [BlueprintIcons_16.GanttChart]: "61894",
  [BlueprintIcons_16.Geofence]: "61895",
  [BlueprintIcons_16.Geolocation]: "61896",
  [BlueprintIcons_16.Geosearch]: "61897",
  [BlueprintIcons_16.Geotime]: "62276",
  [BlueprintIcons_16.GitBranch]: "61898",
  [BlueprintIcons_16.GitCommit]: "61899",
  [BlueprintIcons_16.GitMerge]: "61900",
  [BlueprintIcons_16.GitNewBranch]: "61901",
  [BlueprintIcons_16.GitPull]: "61902",
  [BlueprintIcons_16.GitPush]: "61903",
  [BlueprintIcons_16.GitRepo]: "61904",
  [BlueprintIcons_16.Glass]: "61905",
  [BlueprintIcons_16.GlobeNetwork]: "61906",
  [BlueprintIcons_16.Globe]: "61907",
  [BlueprintIcons_16.GraphRemove]: "61908",
  [BlueprintIcons_16.Graph]: "61909",
  [BlueprintIcons_16.GreaterThanOrEqualTo]: "61910",
  [BlueprintIcons_16.GreaterThan]: "61911",
  [BlueprintIcons_16.GridView]: "61912",
  [BlueprintIcons_16.Grid]: "61913",
  [BlueprintIcons_16.GroupObjects]: "61914",
  [BlueprintIcons_16.GroupedBarChart]: "61915",
  [BlueprintIcons_16.HandDown]: "61916",
  [BlueprintIcons_16.HandLeft]: "61917",
  [BlueprintIcons_16.HandRight]: "61918",
  [BlueprintIcons_16.HandUp]: "61919",
  [BlueprintIcons_16.Hand]: "61920",
  [BlueprintIcons_16.Hat]: "61921",
  [BlueprintIcons_16.HeaderOne]: "61922",
  [BlueprintIcons_16.HeaderThree]: "61923",
  [BlueprintIcons_16.HeaderTwo]: "61924",
  [BlueprintIcons_16.Header]: "61925",
  [BlueprintIcons_16.Headset]: "61926",
  [BlueprintIcons_16.HeartBroken]: "61927",
  [BlueprintIcons_16.Heart]: "61928",
  [BlueprintIcons_16.HeatGrid]: "61929",
  [BlueprintIcons_16.Heatmap]: "61930",
  [BlueprintIcons_16.Helicopter]: "61931",
  [BlueprintIcons_16.Help]: "61932",
  [BlueprintIcons_16.HelperManagement]: "61933",
  [BlueprintIcons_16.HighPriority]: "61934",
  [BlueprintIcons_16.HighVoltagePole]: "62259",
  [BlueprintIcons_16.Highlight]: "61935",
  [BlueprintIcons_16.History]: "61936",
  [BlueprintIcons_16.Home]: "61937",
  [BlueprintIcons_16.HorizontalBarChartAsc]: "61938",
  [BlueprintIcons_16.HorizontalBarChartDesc]: "61939",
  [BlueprintIcons_16.HorizontalBarChart]: "61940",
  [BlueprintIcons_16.HorizontalDistribution]: "61941",
  [BlueprintIcons_16.HorizontalInbetween]: "62249",
  [BlueprintIcons_16.Hurricane]: "61942",
  [BlueprintIcons_16.IdNumber]: "61943",
  [BlueprintIcons_16.ImageRotateLeft]: "61944",
  [BlueprintIcons_16.ImageRotateRight]: "61945",
  [BlueprintIcons_16.Import]: "61946",
  [BlueprintIcons_16.InboxFiltered]: "61947",
  [BlueprintIcons_16.InboxGeo]: "61948",
  [BlueprintIcons_16.InboxSearch]: "61949",
  [BlueprintIcons_16.InboxUpdate]: "61950",
  [BlueprintIcons_16.Inbox]: "61951",
  [BlueprintIcons_16.InfoSign]: "61952",
  [BlueprintIcons_16.Inheritance]: "61953",
  [BlueprintIcons_16.InheritedGroup]: "61954",
  [BlueprintIcons_16.InnerJoin]: "61955",
  [BlueprintIcons_16.Insert]: "61956",
  [BlueprintIcons_16.Intelligence]: "62263",
  [BlueprintIcons_16.Intersection]: "61957",
  [BlueprintIcons_16.IpAddress]: "61958",
  [BlueprintIcons_16.IssueClosed]: "61959",
  [BlueprintIcons_16.IssueNew]: "61960",
  [BlueprintIcons_16.Issue]: "61961",
  [BlueprintIcons_16.Italic]: "61962",
  [BlueprintIcons_16.JoinTable]: "61963",
  [BlueprintIcons_16.KeyBackspace]: "61964",
  [BlueprintIcons_16.KeyCommand]: "61965",
  [BlueprintIcons_16.KeyControl]: "61966",
  [BlueprintIcons_16.KeyDelete]: "61967",
  [BlueprintIcons_16.KeyEnter]: "61968",
  [BlueprintIcons_16.KeyEscape]: "61969",
  [BlueprintIcons_16.KeyOption]: "61970",
  [BlueprintIcons_16.KeyShift]: "61971",
  [BlueprintIcons_16.KeyTab]: "61972",
  [BlueprintIcons_16.Key]: "61973",
  [BlueprintIcons_16.KnownVehicle]: "61974",
  [BlueprintIcons_16.LabTest]: "61975",
  [BlueprintIcons_16.Label]: "61976",
  [BlueprintIcons_16.LayerOutline]: "61977",
  [BlueprintIcons_16.Layer]: "61978",
  [BlueprintIcons_16.Layers]: "61979",
  [BlueprintIcons_16.LayoutAuto]: "61980",
  [BlueprintIcons_16.LayoutBalloon]: "61981",
  [BlueprintIcons_16.LayoutCircle]: "61982",
  [BlueprintIcons_16.LayoutGrid]: "61983",
  [BlueprintIcons_16.LayoutGroupBy]: "61984",
  [BlueprintIcons_16.LayoutHierarchy]: "61985",
  [BlueprintIcons_16.LayoutLinear]: "61986",
  [BlueprintIcons_16.LayoutSkewGrid]: "61987",
  [BlueprintIcons_16.LayoutSortedClusters]: "61988",
  [BlueprintIcons_16.Layout]: "61989",
  [BlueprintIcons_16.Learning]: "61990",
  [BlueprintIcons_16.LeftJoin]: "61991",
  [BlueprintIcons_16.LengthenText]: "62270",
  [BlueprintIcons_16.LessThanOrEqualTo]: "61992",
  [BlueprintIcons_16.LessThan]: "61993",
  [BlueprintIcons_16.Lifesaver]: "61994",
  [BlueprintIcons_16.Lightbulb]: "61995",
  [BlueprintIcons_16.Lightning]: "61996",
  [BlueprintIcons_16.Link]: "61997",
  [BlueprintIcons_16.ListColumns]: "61998",
  [BlueprintIcons_16.ListDetailView]: "61999",
  [BlueprintIcons_16.List]: "62000",
  [BlueprintIcons_16.Locate]: "62001",
  [BlueprintIcons_16.Lock]: "62002",
  [BlueprintIcons_16.Locomotive]: "62267",
  [BlueprintIcons_16.LogIn]: "62003",
  [BlueprintIcons_16.LogOut]: "62004",
  [BlueprintIcons_16.LowVoltagePole]: "62258",
  [BlueprintIcons_16.Manual]: "62005",
  [BlueprintIcons_16.ManuallyEnteredData]: "62006",
  [BlueprintIcons_16.ManyToMany]: "62007",
  [BlueprintIcons_16.ManyToOne]: "62008",
  [BlueprintIcons_16.MapCreate]: "62009",
  [BlueprintIcons_16.MapMarker]: "62010",
  [BlueprintIcons_16.Map]: "62011",
  [BlueprintIcons_16.Maximize]: "62012",
  [BlueprintIcons_16.Media]: "62013",
  [BlueprintIcons_16.MenuClosed]: "62014",
  [BlueprintIcons_16.MenuOpen]: "62015",
  [BlueprintIcons_16.Menu]: "62016",
  [BlueprintIcons_16.MergeColumns]: "62017",
  [BlueprintIcons_16.MergeLinks]: "62018",
  [BlueprintIcons_16.Microphone]: "62275",
  [BlueprintIcons_16.Minimize]: "62019",
  [BlueprintIcons_16.Minus]: "62020",
  [BlueprintIcons_16.MobilePhone]: "62021",
  [BlueprintIcons_16.MobileVideo]: "62022",
  [BlueprintIcons_16.ModalFilled]: "62023",
  [BlueprintIcons_16.Modal]: "62024",
  [BlueprintIcons_16.Model]: "62269",
  [BlueprintIcons_16.Moon]: "62025",
  [BlueprintIcons_16.More]: "62026",
  [BlueprintIcons_16.Mountain]: "62027",
  [BlueprintIcons_16.Move]: "62028",
  [BlueprintIcons_16.Mugshot]: "62029",
  [BlueprintIcons_16.MultiSelect]: "62030",
  [BlueprintIcons_16.Music]: "62031",
  [BlueprintIcons_16.Nest]: "62032",
  [BlueprintIcons_16.NewDrawing]: "62033",
  [BlueprintIcons_16.NewGridItem]: "62034",
  [BlueprintIcons_16.NewLayer]: "62035",
  [BlueprintIcons_16.NewLayers]: "62036",
  [BlueprintIcons_16.NewLink]: "62037",
  [BlueprintIcons_16.NewObject]: "62038",
  [BlueprintIcons_16.NewPerson]: "62039",
  [BlueprintIcons_16.NewPrescription]: "62040",
  [BlueprintIcons_16.NewShield]: "62281",
  [BlueprintIcons_16.NewTextBox]: "62041",
  [BlueprintIcons_16.Ninja]: "62042",
  [BlueprintIcons_16.NotEqualTo]: "62043",
  [BlueprintIcons_16.NotificationsSnooze]: "62044",
  [BlueprintIcons_16.NotificationsUpdated]: "62045",
  [BlueprintIcons_16.Notifications]: "62046",
  [BlueprintIcons_16.NumberedList]: "62047",
  [BlueprintIcons_16.Numerical]: "62048",
  [BlueprintIcons_16.Office]: "62049",
  [BlueprintIcons_16.Offline]: "62050",
  [BlueprintIcons_16.OilField]: "62051",
  [BlueprintIcons_16.OneColumn]: "62052",
  [BlueprintIcons_16.OneToMany]: "62053",
  [BlueprintIcons_16.OneToOne]: "62054",
  [BlueprintIcons_16.OpenApplication]: "62251",
  [BlueprintIcons_16.Outdated]: "62055",
  [BlueprintIcons_16.PageLayout]: "62056",
  [BlueprintIcons_16.PanelStats]: "62057",
  [BlueprintIcons_16.PanelTable]: "62058",
  [BlueprintIcons_16.Paperclip]: "62059",
  [BlueprintIcons_16.Paragraph]: "62060",
  [BlueprintIcons_16.PasteVariable]: "62278",
  [BlueprintIcons_16.PathSearch]: "62061",
  [BlueprintIcons_16.Path]: "62062",
  [BlueprintIcons_16.Pause]: "62063",
  [BlueprintIcons_16.People]: "62064",
  [BlueprintIcons_16.Percentage]: "62065",
  [BlueprintIcons_16.Person]: "62066",
  [BlueprintIcons_16.PhoneCall]: "62279",
  [BlueprintIcons_16.PhoneForward]: "62280",
  [BlueprintIcons_16.Phone]: "62067",
  [BlueprintIcons_16.PieChart]: "62068",
  [BlueprintIcons_16.Pin]: "62069",
  [BlueprintIcons_16.PivotTable]: "62070",
  [BlueprintIcons_16.Pivot]: "62071",
  [BlueprintIcons_16.Play]: "62072",
  [BlueprintIcons_16.Playbook]: "62244",
  [BlueprintIcons_16.Plus]: "62073",
  [BlueprintIcons_16.PolygonFilter]: "62074",
  [BlueprintIcons_16.Power]: "62075",
  [BlueprintIcons_16.PredictiveAnalysis]: "62076",
  [BlueprintIcons_16.Prescription]: "62077",
  [BlueprintIcons_16.Presentation]: "62078",
  [BlueprintIcons_16.Print]: "62079",
  [BlueprintIcons_16.Projects]: "62080",
  [BlueprintIcons_16.Properties]: "62081",
  [BlueprintIcons_16.Property]: "62082",
  [BlueprintIcons_16.PublishFunction]: "62083",
  [BlueprintIcons_16.Pulse]: "62084",
  [BlueprintIcons_16.Rain]: "62085",
  [BlueprintIcons_16.Random]: "62086",
  [BlueprintIcons_16.Record]: "62087",
  [BlueprintIcons_16.RectHeight]: "62245",
  [BlueprintIcons_16.RectWidth]: "62246",
  [BlueprintIcons_16.Rectangle]: "62241",
  [BlueprintIcons_16.Redo]: "62088",
  [BlueprintIcons_16.Refresh]: "62089",
  [BlueprintIcons_16.Regex]: "62255",
  [BlueprintIcons_16.RegressionChart]: "62090",
  [BlueprintIcons_16.RemoveColumnLeft]: "62091",
  [BlueprintIcons_16.RemoveColumnRight]: "62092",
  [BlueprintIcons_16.RemoveColumn]: "62093",
  [BlueprintIcons_16.RemoveRowBottom]: "62094",
  [BlueprintIcons_16.RemoveRowTop]: "62095",
  [BlueprintIcons_16.Remove]: "62096",
  [BlueprintIcons_16.Repeat]: "62097",
  [BlueprintIcons_16.Reset]: "62098",
  [BlueprintIcons_16.Resolve]: "62099",
  [BlueprintIcons_16.Rig]: "62100",
  [BlueprintIcons_16.RightJoin]: "62101",
  [BlueprintIcons_16.Ring]: "62102",
  [BlueprintIcons_16.RocketSlant]: "62103",
  [BlueprintIcons_16.Rocket]: "62104",
  [BlueprintIcons_16.RotateDocument]: "62105",
  [BlueprintIcons_16.RotatePage]: "62106",
  [BlueprintIcons_16.Route]: "62107",
  [BlueprintIcons_16.Satellite]: "62108",
  [BlueprintIcons_16.Saved]: "62109",
  [BlueprintIcons_16.ScatterPlot]: "62110",
  [BlueprintIcons_16.SearchAround]: "62111",
  [BlueprintIcons_16.SearchTemplate]: "62112",
  [BlueprintIcons_16.SearchText]: "62113",
  [BlueprintIcons_16.Search]: "62114",
  [BlueprintIcons_16.SegmentedControl]: "62115",
  [BlueprintIcons_16.Select]: "62116",
  [BlueprintIcons_16.Selection]: "62117",
  [BlueprintIcons_16.SendMessage]: "62118",
  [BlueprintIcons_16.SendToGraph]: "62119",
  [BlueprintIcons_16.SendToMap]: "62120",
  [BlueprintIcons_16.SendTo]: "62121",
  [BlueprintIcons_16.Sensor]: "62268",
  [BlueprintIcons_16.SeriesAdd]: "62122",
  [BlueprintIcons_16.SeriesConfiguration]: "62123",
  [BlueprintIcons_16.SeriesDerived]: "62124",
  [BlueprintIcons_16.SeriesFiltered]: "62125",
  [BlueprintIcons_16.SeriesSearch]: "62126",
  [BlueprintIcons_16.Settings]: "62127",
  [BlueprintIcons_16.Shapes]: "62128",
  [BlueprintIcons_16.Share]: "62129",
  [BlueprintIcons_16.SharedFilter]: "62130",
  [BlueprintIcons_16.Shield]: "62131",
  [BlueprintIcons_16.Ship]: "62132",
  [BlueprintIcons_16.Shop]: "62133",
  [BlueprintIcons_16.ShoppingCart]: "62134",
  [BlueprintIcons_16.ShortenText]: "62271",
  [BlueprintIcons_16.SignalSearch]: "62135",
  [BlueprintIcons_16.SimCard]: "62136",
  [BlueprintIcons_16.Slash]: "62137",
  [BlueprintIcons_16.SmallCross]: "62138",
  [BlueprintIcons_16.SmallInfoSign]: "62260",
  [BlueprintIcons_16.SmallMinus]: "62139",
  [BlueprintIcons_16.SmallPlus]: "62140",
  [BlueprintIcons_16.SmallSquare]: "62141",
  [BlueprintIcons_16.SmallTick]: "62142",
  [BlueprintIcons_16.Snowflake]: "62143",
  [BlueprintIcons_16.SocialMedia]: "62144",
  [BlueprintIcons_16.SortAlphabeticalDesc]: "62145",
  [BlueprintIcons_16.SortAlphabetical]: "62146",
  [BlueprintIcons_16.SortAsc]: "62147",
  [BlueprintIcons_16.SortDesc]: "62148",
  [BlueprintIcons_16.SortNumericalDesc]: "62149",
  [BlueprintIcons_16.SortNumerical]: "62150",
  [BlueprintIcons_16.Sort]: "62151",
  [BlueprintIcons_16.SpellCheck]: "62272",
  [BlueprintIcons_16.SplitColumns]: "62152",
  [BlueprintIcons_16.Square]: "62153",
  [BlueprintIcons_16.StackedChart]: "62154",
  [BlueprintIcons_16.StadiumGeometry]: "62155",
  [BlueprintIcons_16.StarEmpty]: "62156",
  [BlueprintIcons_16.Star]: "62157",
  [BlueprintIcons_16.StepBackward]: "62158",
  [BlueprintIcons_16.StepChart]: "62159",
  [BlueprintIcons_16.StepForward]: "62160",
  [BlueprintIcons_16.Stop]: "62161",
  [BlueprintIcons_16.Stopwatch]: "62162",
  [BlueprintIcons_16.Strikethrough]: "62163",
  [BlueprintIcons_16.Style]: "62164",
  [BlueprintIcons_16.Subscript]: "62265",
  [BlueprintIcons_16.Superscript]: "62266",
  [BlueprintIcons_16.SwapHorizontal]: "62165",
  [BlueprintIcons_16.SwapVertical]: "62166",
  [BlueprintIcons_16.Switch]: "62167",
  [BlueprintIcons_16.SymbolCircle]: "62168",
  [BlueprintIcons_16.SymbolCross]: "62169",
  [BlueprintIcons_16.SymbolDiamond]: "62170",
  [BlueprintIcons_16.SymbolRectangle]: "62242",
  [BlueprintIcons_16.SymbolSquare]: "62171",
  [BlueprintIcons_16.SymbolTriangleDown]: "62172",
  [BlueprintIcons_16.SymbolTriangleUp]: "62173",
  [BlueprintIcons_16.Syringe]: "62174",
  [BlueprintIcons_16.Tag]: "62175",
  [BlueprintIcons_16.TakeAction]: "62176",
  [BlueprintIcons_16.Tank]: "62177",
  [BlueprintIcons_16.Target]: "62178",
  [BlueprintIcons_16.Taxi]: "62179",
  [BlueprintIcons_16.Temperature]: "62180",
  [BlueprintIcons_16.TextHighlight]: "62181",
  [BlueprintIcons_16.ThDerived]: "62182",
  [BlueprintIcons_16.ThDisconnect]: "62183",
  [BlueprintIcons_16.ThFiltered]: "62184",
  [BlueprintIcons_16.ThList]: "62185",
  [BlueprintIcons_16.Th]: "62186",
  [BlueprintIcons_16.ThirdParty]: "62187",
  [BlueprintIcons_16.ThumbsDown]: "62188",
  [BlueprintIcons_16.ThumbsUp]: "62189",
  [BlueprintIcons_16.TickCircle]: "62190",
  [BlueprintIcons_16.Tick]: "62191",
  [BlueprintIcons_16.Time]: "62192",
  [BlueprintIcons_16.TimelineAreaChart]: "62193",
  [BlueprintIcons_16.TimelineBarChart]: "62194",
  [BlueprintIcons_16.TimelineEvents]: "62195",
  [BlueprintIcons_16.TimelineLineChart]: "62196",
  [BlueprintIcons_16.Tint]: "62197",
  [BlueprintIcons_16.Torch]: "62198",
  [BlueprintIcons_16.Tractor]: "62199",
  [BlueprintIcons_16.Train]: "62200",
  [BlueprintIcons_16.Translate]: "62201",
  [BlueprintIcons_16.Trash]: "62202",
  [BlueprintIcons_16.Tree]: "62203",
  [BlueprintIcons_16.TrendingDown]: "62204",
  [BlueprintIcons_16.TrendingUp]: "62205",
  [BlueprintIcons_16.Truck]: "62206",
  [BlueprintIcons_16.TwoColumns]: "62207",
  [BlueprintIcons_16.Unarchive]: "62208",
  [BlueprintIcons_16.Underline]: "62209",
  [BlueprintIcons_16.Undo]: "62210",
  [BlueprintIcons_16.UngroupObjects]: "62211",
  [BlueprintIcons_16.UnknownVehicle]: "62212",
  [BlueprintIcons_16.Unlink]: "62277",
  [BlueprintIcons_16.Unlock]: "62213",
  [BlueprintIcons_16.Unpin]: "62214",
  [BlueprintIcons_16.Unresolve]: "62215",
  [BlueprintIcons_16.Updated]: "62216",
  [BlueprintIcons_16.Upload]: "62217",
  [BlueprintIcons_16.User]: "62218",
  [BlueprintIcons_16.Variable]: "62219",
  [BlueprintIcons_16.VerticalBarChartAsc]: "62220",
  [BlueprintIcons_16.VerticalBarChartDesc]: "62221",
  [BlueprintIcons_16.VerticalDistribution]: "62222",
  [BlueprintIcons_16.VerticalInbetween]: "62250",
  [BlueprintIcons_16.Video]: "62223",
  [BlueprintIcons_16.Virus]: "62224",
  [BlueprintIcons_16.VolumeDown]: "62225",
  [BlueprintIcons_16.VolumeOff]: "62226",
  [BlueprintIcons_16.VolumeUp]: "62227",
  [BlueprintIcons_16.Walk]: "62228",
  [BlueprintIcons_16.WarningSign]: "62229",
  [BlueprintIcons_16.WaterfallChart]: "62230",
  [BlueprintIcons_16.Waves]: "62231",
  [BlueprintIcons_16.WidgetButton]: "62232",
  [BlueprintIcons_16.WidgetFooter]: "62233",
  [BlueprintIcons_16.WidgetHeader]: "62234",
  [BlueprintIcons_16.Widget]: "62235",
  [BlueprintIcons_16.Wind]: "62236",
  [BlueprintIcons_16.Wrench]: "62237",
  [BlueprintIcons_16.ZoomIn]: "62238",
  [BlueprintIcons_16.ZoomOut]: "62239",
  [BlueprintIcons_16.ZoomToFit]: "62240",
};
